const MODAL_WIDTH_SM = 480;
const MODAL_WIDTH_MD = 640;
const MODAL_WIDTH_LG = 960;
const MODAL_WIDTH_XL = 1024;
const MODAL_HEIGHT_XS = 320;
const MODAL_HEIGHT_MD = 640;
const MARGIN_XS = 4;
const MARGIN_SM = 8;
const MARGIN_MD = 16;
const MARGIN_LG = 24;
const MARGIN_XL = 32;
const PADDING_XS = 4;
const PADDING_SM = 8;
const PADDING_MD = 16;
const GUTTER_XS = 4;
const GUTTER_SM = 8;
const GUTTER_MD = 16;
const SPAN_ONE_QUARTER = 6;
const SPAN_ONE_THIRD = 8;
const SPAN_HALF = 12;
const SPAN_TWO_THIRDS = 16;
const SPAN_TWO_QUARTERS = 12;
const SPAN_THREE_QUARTERS = 18;
const SPAN_FULL = 24;
const COLOR_FONT_DISABLED = 'rgba(0,0,0,.25)';
const CSS_HIDDEN = {display: 'none'};
const CSS_POINTER = {cursor: 'pointer'};
const Z_INDEX_SPINNER = 999;
const Z_INDEX_MODAL = 1000;
const Z_INDEX_ENHANCED_MODAL = 998;
const TABLE_COL_MIN_WIDTH_ID = 100;
const TABLE_COL_MIN_WIDTH_NAME = 150;

module.exports.MODAL_WIDTH_SM = MODAL_WIDTH_SM;
module.exports.MODAL_WIDTH_MD = MODAL_WIDTH_MD;
module.exports.MODAL_WIDTH_LG = MODAL_WIDTH_LG;
module.exports.MODAL_WIDTH_XL = MODAL_WIDTH_XL;
module.exports.MODAL_HEIGHT_XS = MODAL_HEIGHT_XS;
module.exports.MODAL_HEIGHT_MD = MODAL_HEIGHT_MD;
module.exports.MARGIN_XS = MARGIN_XS;
module.exports.MARGIN_SM = MARGIN_SM;
module.exports.MARGIN_MD = MARGIN_MD;
module.exports.MARGIN_LG = MARGIN_LG;
module.exports.MARGIN_XL = MARGIN_XL;
module.exports.PADDING_XS = PADDING_XS;
module.exports.PADDING_SM = PADDING_SM;
module.exports.PADDING_MD = PADDING_MD;
module.exports.GUTTER_XS = GUTTER_XS;
module.exports.GUTTER_SM = GUTTER_SM;
module.exports.GUTTER_MD = GUTTER_MD;
module.exports.SPAN_ONE_QUARTER = SPAN_ONE_QUARTER;
module.exports.SPAN_ONE_THIRD = SPAN_ONE_THIRD;
module.exports.SPAN_HALF = SPAN_HALF;
module.exports.SPAN_TWO_THIRDS = SPAN_TWO_THIRDS;
module.exports.SPAN_THREE_QUARTERS = SPAN_THREE_QUARTERS;
module.exports.SPAN_TWO_QUARTERS = SPAN_TWO_QUARTERS;
module.exports.SPAN_FULL = SPAN_FULL;
module.exports.COLOR_FONT_DISABLED = COLOR_FONT_DISABLED;
module.exports.CSS_HIDDEN = CSS_HIDDEN;
module.exports.CSS_POINTER = CSS_POINTER;
module.exports.Z_INDEX_SPINNER = Z_INDEX_SPINNER;
module.exports.Z_INDEX_MODAL = Z_INDEX_MODAL;
module.exports.Z_INDEX_ENHANCED_MODAL = Z_INDEX_ENHANCED_MODAL;
module.exports.TABLE_COL_MIN_WIDTH_ID = TABLE_COL_MIN_WIDTH_ID;
module.exports.TABLE_COL_MIN_WIDTH_NAME = TABLE_COL_MIN_WIDTH_NAME;